import React from 'react';
import HelpLink from 'components/pure/admin/HelpLink';

export default class EditArchivingProfilePageHelp extends React.PureComponent {
  render() {
    return (
      <HelpLink popoverClassName={'department-profile-help-text'}>
        <p>
          Archiving profiles allow you to define how long calls remain available to your users in
          the Coach360 system.
        </p>
        <p>
          Calls can be automatically removed after a preset number of days, exceptions can be
          granted for calls that are annotated, shared, or added to a library.{' '}
        </p>
      </HelpLink>
    );
  }
}
